import z from "zod";

export const zCmpOp = z.enum(["<", "<=", ">", ">=", "=", "!="]);
export type ZCmpOp = z.infer<typeof zCmpOp>;
